import { useEffect, useState, useMemo, useCallback } from "react";
import { usePriceBlocsContext } from "@priceblocs/react-priceblocs-js";

const usePreviewInvoice = ({ subscription, prices }) => {
  const subId = subscription && subscription.id;
  const {
    previewInvoice,
    values: {
      form: {
        checkout: { items }
      }
    }
  } = usePriceBlocsContext();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const itemPrices = useMemo(() => items.map(({ price: { id } }) => id), [
    items
  ]);
  const previewItems = useMemo(
    () => (Array.isArray(prices) && prices.length > 0 ? prices : itemPrices),
    [prices, itemPrices]
  );

  const getPreview = useCallback(async () => {
    setLoading(true);
    const previewData = await previewInvoice({
      items: previewItems,
      subscription: subId
    });
    setData(previewData);
    setLoading(false);
  }, [previewItems, subId, previewInvoice]);

  useEffect(() => {
    if (!data && !loading) {
      getPreview();
    }
  }, [data, loading, previewItems, subId, getPreview]);

  return {
    getPreview,
    data,
    loading,
    setLoading
  };
};

export default usePreviewInvoice;
